(() => {
  window.addEventListener("change", () => {
    setTimeout(() => {
      window.Abra?.render();
    }, 150);
  });

  document.querySelectorAll(".swiper-slide select").forEach(function(select) {
    select.addEventListener("change", function(e) {
      var variantId = e.target.value;
      var container = select.closest("[data-abra-container]");
      if (container && variantId) {
        container.setAttribute("data-variant-id", variantId);
      }
    });
  });
})();

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(() => {
    document.querySelectorAll(".swiper-slide select").forEach(function(select) {
      var variantId = select.value;
      var container = select.closest("[data-abra-container]");
      if (container && variantId) {
        container.setAttribute("data-variant-id", variantId);
      }
      
      setTimeout(() => {
        window.Abra?.render();
      }, 150);
    });
  }, 3000);
});

// Bundle variants handle 
(() => {
  let isUpdating = false;
  let lastVariantId = null;
  
  const updateVariantPricing = () => {
    if (isUpdating) {
      return;
    }
    
    isUpdating = true;
    
    const currentProductHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantId = urlParams.get('variant') || document.querySelector('#fallback-selector-template--18193389387885__main_product_eggnog_jFrpTb')?.value;
    
    if (lastVariantId === currentVariantId) {
      isUpdating = false;
      return;
    }
    
    lastVariantId = currentVariantId;
    
    const updatedPrice = document.querySelector('.updated-product-price');
    const updatedComparePrice = document.querySelector('.updated-compare-at-price');
    
    if (updatedPrice) {
      const priceValue = updatedPrice.innerHTML.trim();
      
      const oneTimePriceContainer = document.querySelector('.loop-one-time-purchase-option-price-container');
      if (oneTimePriceContainer) {
        oneTimePriceContainer.setAttribute('data-variant-id', currentVariantId || '');
        oneTimePriceContainer.setAttribute('data-product-handle', currentProductHandle || '');
        
        const oneTimePriceAmount = oneTimePriceContainer.querySelector('.loop-one-time-purchase-option-price-amount');
        if (oneTimePriceAmount && priceValue) {
          oneTimePriceAmount.innerHTML = priceValue;
        }
      }
      
      if (updatedComparePrice) {
        const comparePriceValue = updatedComparePrice.innerHTML.trim();
        const comparePriceEl = document.querySelector('._compare_price');
        if (comparePriceEl && comparePriceValue) {
          comparePriceEl.innerHTML = comparePriceValue;
        }
      }
    }
    
    const flavourLinks = document.querySelectorAll('.desktop_flavours_list .inner_shakes a');
    
    flavourLinks.forEach((link) => {
      const href = link.getAttribute('href');
      const productHandle = href?.split('/products/')[1]?.split('?')[0];
      link.setAttribute('data-product-handle', productHandle || '');
    });
    
    if (window.Abra && typeof window.Abra.render === 'function') {
      window.Abra.render();
    }
    
    setTimeout(() => {
      isUpdating = false;
    }, 100);
  };
  
  const observePriceChanges = () => {
    const priceElement = document.querySelector('.updated-product-price');
    if (priceElement) {
      const observer = new MutationObserver(() => {
        if (!isUpdating) {
          setTimeout(updateVariantPricing, 50);
        }
      });
      observer.observe(priceElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };
  
  const observeVariantSelect = () => {
    const variantSelect = document.querySelector('#fallback-selector-template--18193389387885__main_product_eggnog_jFrpTb');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        setTimeout(updateVariantPricing, 100);
      });
    }
  };
  
  const observeUrlChanges = () => {
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        setTimeout(updateVariantPricing, 100);
      }
    }).observe(document, {subtree: true, childList: true});
  };
  
  const init = () => {
    updateVariantPricing();
    observePriceChanges();
    observeVariantSelect();
    observeUrlChanges();
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.addEventListener('load', () => {
    setTimeout(updateVariantPricing, 500);
  });
})();